// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const sitesExportFields = [
  {
    titleIntlKey: "sites.columns.address.title",
    fields: [
      "addressAddress1",
      "addressAddress2",
      "addressAddress3",
      "addressCity",
      "addressCountryCode",
      "addressLatitude",
      "addressLongitude",
      "addressPostalCode",
      "addressState",
    ],
  },
  {
    titleIntlKey: "sites.columns.site.title",
    fields: ["siteId", "forceSiteId", "externalId", "abbreviationLatin", "abbreviationLocal", "countryCode", "nameLatin", "nameLocal"],
  },
  {
    titleIntlKey: "sites.columns.social.title",
    fields: ["socialFacebook", "socialInstagram", "socialTwitter", "socialWebsite", "socialWikipedia"],
  },
];

export const defaultSitesExportFieldNames = ["siteId", "nameLocal", "countryCode"];
